/* eslint-disable camelcase */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { actions, Form } from 'forms/rrf';
import { updateOutletRest } from '../../../actions/outlet';
import ArrowButton from '../../common/button-arrow';
import DeliveryAddressPartial from '../../delivery-address/delivery-address-partial';

const OUTLET_MODEL = 'deep.admin_outlet_view';

class OutletRewardDetails extends Component {
  handleSubmit = (values) => {
    this.props.dispatch(actions.submitFields('deep.admin_outlet_view', updateOutletRest(this.props.id, values, this.props.dispatch)));
  };

  render() {
    const {delivery} = this.props;

    return (
      <div className="fluid">
        <Form model={OUTLET_MODEL} onSubmit={this.handleSubmit}>

          <DeliveryAddressPartial addressDetails={delivery} model={OUTLET_MODEL}/>

          <Row className="mg-top-20">
            <Col className="text-right" md={12}>
              <ArrowButton arrow={false}>
                Update
              </ArrowButton>
            </Col>
          </Row>

        </Form>
      </div>
    );
  }
}

export default connect()(OutletRewardDetails);
